// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { ExecutedTransfer } from '@daml.js/dtc-registry/lib/Dtc/Registry/V3/Holding/Transfer';
import { TemplateHistory, useTemplateHistory } from '../../useTemplateHistory';

export const useExecutedTransfers = (): TemplateHistory<ExecutedTransfer> =>
  useTemplateHistory(ExecutedTransfer);
